import { useState, useEffect, useRef } from 'react';
import axios from 'axios';

export default function Chat() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [histLoading, setHistLoading] = useState(true);
  const bottomRef = useRef(null);

  useEffect(() => {
    axios.get('/api/chat/history').then(({ data }) => {
      setMessages(data.map(m => ({ role: m.role, text: m.content })));
    }).catch(() => {}).finally(() => setHistLoading(false));
  }, []);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, loading]);

  const send = async () => {
    const msg = input.trim();
    if (!msg || loading) return;
    setInput('');
    setMessages(prev => [...prev, { role: 'user', text: msg }]);
    setLoading(true);
    try {
      const { data } = await axios.post('/api/chat', { message: msg });
      setMessages(prev => [...prev, { role: 'assistant', text: data.reply }]);
      if (data.crisisDetected) {
        setMessages(prev => [...prev, {
          role: 'crisis',
          text: '⚠️ Am detectat că ai putea trece printr-un moment dificil. Medicul tău a fost notificat. Dacă ai nevoie de ajutor imediat, sună TELVERDE la 0800 800 100 — gratuit, non-stop.'
        }]);
      }
    } catch (err) {
      setMessages(prev => [...prev, { role: 'assistant', text: 'A apărut o eroare. Încearcă din nou.' }]);
    } finally {
      setLoading(false);
    }
  };

  const clearHistory = async () => {
    if (!window.confirm('Ștergi tot istoricul conversației?')) return;
    await axios.delete('/api/chat/history');
    setMessages([]);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {/* Crisis banner */}
      <div className="card-danger" style={{ margin: '12px 20px 0', display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{ flex: 1, fontSize: 12, color: '#7B2D36' }}>
          Criză? Sună <strong>TELVERDE 0800 800 100</strong> — gratuit, non-stop.
        </div>
      </div>

      {/* Messages */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '12px 20px', display: 'flex', flexDirection: 'column', gap: 12 }}>
        {histLoading && <div style={{ color: 'var(--muted)', fontSize: 13, textAlign: 'center', marginTop: 20 }}>Se încarcă istoricul...</div>}
        {!histLoading && messages.length === 0 && (
          <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end' }}>
            <div style={{ width: 28, height: 28, borderRadius: '50%', background: '#E0F5F7', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, flexShrink: 0 }}>🌿</div>
            <div className="bubble bubble-ai">Bună! Sunt aici să te ascult și să te sprijin. Spune-mi cum te simți — nu există răspuns greșit.</div>
          </div>
        )}
        {messages.map((m, i) => (
          <div key={i} style={{ display: 'flex', gap: 8, alignItems: 'flex-end', flexDirection: m.role === 'user' ? 'row-reverse' : 'row' }}>
            {m.role === 'assistant' && (
              <div style={{ width: 28, height: 28, borderRadius: '50%', background: '#E0F5F7', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, flexShrink: 0 }}>🌿</div>
            )}
            {m.role === 'crisis' ? (
              <div style={{ background: '#FEF0F1', border: '1px solid #F5C5C9', borderRadius: 12, padding: '10px 14px', fontSize: 13, lineHeight: 1.5, color: '#7B2D36', maxWidth: '90%' }}>
                {m.text}
              </div>
            ) : (
              <div className={`bubble ${m.role === 'user' ? 'bubble-user' : 'bubble-ai'}`}>{m.text}</div>
            )}
          </div>
        ))}
        {loading && (
          <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end' }}>
            <div style={{ width: 28, height: 28, borderRadius: '50%', background: '#E0F5F7', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, flexShrink: 0 }}>🌿</div>
            <div className="bubble bubble-ai typing"><span/><span/><span/></div>
          </div>
        )}
        <div ref={bottomRef} />
      </div>

      {/* Disclaimer */}
      <div style={{ fontSize: 11, color: 'var(--muted)', textAlign: 'center', padding: '4px 20px' }}>
        AI-ul nu înlocuiește un specialist medical.
      </div>

      {/* Input */}
      <div style={{ display: 'flex', gap: 8, padding: '10px 20px 16px', borderTop: '1px solid var(--border)', background: 'var(--white)', alignItems: 'center' }}>
        <input
          className="input"
          style={{ borderRadius: 22 }}
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && !e.shiftKey && send()}
          placeholder="Scrie un mesaj..."
          disabled={loading}
        />
        <button className="btn btn-primary" style={{ borderRadius: '50%', width: 38, height: 38, padding: 0, flexShrink: 0 }} onClick={send} disabled={loading || !input.trim()}>↑</button>
      </div>
      {messages.length > 0 && (
        <div style={{ textAlign: 'center', paddingBottom: 10 }}>
          <button onClick={clearHistory} style={{ fontSize: 11, color: 'var(--muted)', background: 'none', border: 'none', cursor: 'pointer' }}>Șterge istoricul</button>
        </div>
      )}
    </div>
  );
}
